import getCbtClient, { cbtResponse } from "../cbtClient";

export async function listReasonCodes({
  cbtToken,
  customerUsername,
  cbtApiUrl,
  onlyFlight,
  onlyHotel,
}) {
  if (!cbtToken) return;

  const cbtClient = await getCbtClient({
    cbtToken,
    customerUsername,
    cbtApiUrl,
  });

  return cbtResponse(
    cbtClient.get(
      `/reason-codes${onlyFlight ? "?onlyFlight=true" : ""}${
        onlyHotel ? "?onlyHotel=true" : ""
      }`
    )
  );
}
